// src/components/ScrollFade.jsx
import React from "react";
import { useInView } from "react-intersection-observer";
import { Fade } from "@mui/material";

export default function ScrollFade({ children, ...props }) {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.2 });
  return (
    <div ref={ref}>
      <Fade in={inView} timeout={600}>
        <div {...props}>{children}</div>
      </Fade>
    </div>
  );
}
